import React, { useRef } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import { getTheme } from "@icarius-pages/login/selectors";
import { getAppColor } from "@icarius-app/selectors";
import { getProgressColor } from "@icarius-utils/colors";
import useGetRefWidthAndHeight from "@icarius-utils/hooks/useGetRefWidthAndHeight";
import { getChartWidth } from "@icarius-pages/pollReview/components/pollSelection";
import { formatNumberExactDecimals } from "@icarius-utils/format";

const Bar = (props) => {
    const { data, categories, isPercentage, handleColumnClick, getTooltipText } = props;

    const ref = useRef();
    const { theme } = useSelector(getTheme);
    const color = useSelector(getAppColor);
    const { width: containerWidth } = useGetRefWidthAndHeight(ref);

    const chartWidth = getChartWidth(
        categories.length, // cantidad de columnas
        containerWidth - 20 // el - 20 es por el padding
    );

    const getColors = () => {
        if (!isPercentage) return [color];
        return data.map((item) => getProgressColor(item));
    };

    const chartData = {
        series: [{ data }],
        options: {
            chart: {
                type: "bar",
                height: 350,
                width: chartWidth,
                toolbar: {
                    show: false,
                },
                events: {
                    dataPointSelection(event, chartContext, config) {
                        if (!handleColumnClick) return;
                        handleColumnClick(config.dataPointIndex);
                    },
                },
            },
            colors: getColors(),
            plotOptions: {
                bar: {
                    columnWidth: "45%",
                    distributed: true,
                },
            },
            xaxis: {
                categories: categories,
                labels: {
                    trim: true,
                    style: {
                        colors: "var(--mainText)",
                    },
                },
            },
            yaxis: {
                min: isPercentage ? 0 : undefined,
                max: isPercentage ? 100 : undefined,
                labels: {
                    style: {
                        colors: "var(--mainText)",
                    },
                    formatter: (val) => formatNumberExactDecimals(val, isPercentage ? 2 : 0),
                },
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                show: false,
            },
            states: {
                active: {
                    filter: {
                        type: "none",
                    },
                },
            },
            tooltip: {
                marker: {
                    show: false,
                },
                followCursor: true,
                theme: theme,
                y: {
                    formatter: (value, { dataPointIndex }) =>
                        `${formatNumberExactDecimals(value, isPercentage ? 2 : 0)}${isPercentage ? "%" : ""}${
                            getTooltipText ? ` ${getTooltipText(dataPointIndex)}` : ""
                        }`,
                    title: {
                        formatter: () => "",
                    },
                },
            },
        },
    };

    return (
        <div ref={ref} style={{ padding: 10, overflow: "auto" }}>
            <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type={chartData.options.chart.type}
                height={chartData.options.chart.height}
                width={chartData.options.chart.width}
            />
        </div>
    );
};

export default Bar;
